import { useTranslation } from 'react-i18next'

const GrownupStart = (props) => {
  const { t } = useTranslation()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="grownup-start-title"
      fill="none"
      {...props}
    >
      <title id="grownup-start-title">{t('antagonists:grownup:components:start')}</title>
      <defs>
        <clipPath id="grownup-b">
          <path
            d="M1541.81 210.5c-4.36.28-15.78 24.52-33.01 30.1-17.24 5.58-18.69 6.31-19.42 11.65-.73 5.34 2.91 12.62 1.46 14.32-1.46 1.7-5.1-7.28-8.25-8.01-3.16-.73-6.8 1.7-4.37 8.98 2.43 7.28 7.77 14.32 10.68 13.84 2.91-.49 4.13-1.21 4.13-1.21s0 8.5 7.53 13.35c7.53 4.86 16.26 16.02 33.26 12.87 16.99-3.16 23.3-15.05 26.22-20.15 2.91-5.1 2.91-13.84 2.91-13.84s7.25 3.49 8.95-.15c1.7-3.64.76-5.92 1-14.9s0-11.89-3.16-11.41 0 16.75-.97 19.42c-.97 2.67-2.18-.73-3.64-3.88-1.46-3.16-5.58-9.95-10.68-23.3-5.1-13.35-5.1-28.16-12.62-27.67Z"
            style={{
              fill: '#dfbe84',
            }}
          />
        </clipPath>
        <clipPath id="grownup-c">
          <path
            d="M1499.25 282.7s2.48 17.37 1.51 23.41c-.97 6.04 9.28 25.25 18.99 33.98 9.71 8.74 18.12 13.27 18.12 13.27s11.11-11.76 16.83-19.53c5.72-7.77 6.47-18.88 4.75-22.22s-4.1-4.53-4.53-10.14c-.43-5.61 0-12.19 0-12.19l-55.67-6.58Z"
            style={{
              fill: '#dfbe84',
            }}
          />
        </clipPath>
        <style>
          {
            '.d{fill:#f3decd}.e{fill:#f2934a}.f{fill:#e6f1e2}.g{fill:#e3ebde}.h{fill:#ffd628}.i{fill:#dfbe84}.j{fill:#c48648}.k{fill:#d47241}.l{fill:#e2a972}.m{fill:#3d6b2a}.n{fill:#899586}.o{clip-path:url(#grownup-c)}.p{clip-path:url(#grownup-b)}'
          }
        </style>
      </defs>
      <path
        d="M1538.5 940.72c4.79 2.05 11.55 16 12.37 22.06.82 6.06 2 11.75-.6 13.71-2.6 1.96-15.96 3.91-17.87 9.49-1.91 5.58-8.57 15.35-12.2 17.28-4.53 2.41-25.23 8.67-33.39 7.12-8.38-1.59-12.52-5.5-10.73-12.81 2.3-9.39.42-12.78 12.16-20.98 11.74-8.2 27.59-21.05 27.59-21.05s17.87-16.88 22.66-14.83Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1490.84 981.39c.99 6.44 24.27 4.44 29.14 2.9 4.86-1.55 18.94-20.62 21.64-24.15 2.7-3.53 2.43-5.02 1.08-11.01s.81-30.76 0-30.75c-.81 0-28.9-3.21-28.9-3.21s-1.89 30.52-3.24 36.54c-1.35 6.01-9.92 17.12-14.04 21.39-3.93 4.07-5.93 6.65-5.67 8.31Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1609.73 945.24c-4.51 2.67-9.57 17.41-9.65 23.53-.09 6.12-.58 11.93 2.24 13.54 2.82 1.61 16.33 1.78 18.9 7.07 2.57 5.29 10.36 14.11 14.19 15.55 4.79 1.8 26.12 5.28 34.04 2.68 8.14-2.68 11.78-7.11 9.13-14.13-3.41-9.02-1.95-12.63-14.6-19.23s-29.95-17.26-29.95-17.26-19.79-14.41-24.3-11.74Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1661.97 979.35c-.21 6.53-23.59 7.61-28.61 6.71-5.02-.9-21.3-17.99-24.4-21.13-3.11-3.15-3.02-4.67-2.39-10.79.62-6.12-4.49-30.44-3.69-30.54.81-.1 28.34-7 28.34-7s5.54 30.06 7.6 35.85c2.06 5.79 11.91 15.69 16.52 19.39 4.39 3.52 6.69 5.83 6.63 7.5Z"
        style={{
          fill: '#e2a972',
        }}
      />
      <path
        d="M1441.55 560.63s0 41.86 7.97 82.73c7.97 40.86 21.93 96.68 21.93 123.59 0 26.91 5.98 91.7 10.96 125.58 4.98 33.89 14.17 48.79 14.17 48.79s15.95 2.99 26.91 1.99c10.96-1 25.91-5.98 25.91-5.98s1.78-26.86 1.78-79.69-11.96-59.8-9.97-83.72c1.99-23.92-.29-136.74 1-137.54 1.29-.81 41.86 133.56 40.86 156.48-1 22.92-3.99 50.83-1.99 90.7 1.99 39.87 2.41 55.95 2.41 55.95s21.93 3.99 31.89 5.98c9.97 1.99 37.87-11.96 37.87-11.96s4.57-47.97-1.41-84.85c-5.98-36.88-8.97-51.83-6.98-74.75 1.99-22.92 3.99-87.71 1.99-128.57-1.99-40.86-28.9-109.64-28.9-109.64s-174.42 23.92-176.42 24.92Z"
        style={{
          fill: '#ffd628',
        }}
      />
      <path
        d="M1506.98 303.83s-18.38 11.97-35.44 18.97c-17.06 7-40.11 15.43-40.11 15.43s18.24 78.17 13.43 107.48c-4.81 29.31-15.99 104.44-14.24 124.13 1.75 19.68 10.67 51.56 10.67 51.56s37.3-19.34 103.74-25.62c66.44-6.27 88.75-16.11 88.75-16.11s1.92-11.54 4.55-44.34c2.62-32.81-32.94-91.36-27.25-128.54 5.69-37.18 22.26-54.89 14.39-65.82-7.87-10.94-45.4-9.84-61.14-25.58-15.75-15.75-37.66-15.76-37.66-15.76l-19.68 4.21Z"
        style={{
          fill: '#899586',
        }}
      />
      <path
        d="M1554.21 432.15s4.37 12.25 3.06 19.68-1.31 13.12-1.31 13.12 18.89-4.1 26.33-8.91c7.44-4.81 15.23-9.9 15.23-9.9v-11.81s-10.5.44-22.31-1.75c-11.81-2.19-21-.44-21-.44ZM1515.72 502.57c.44-1.31-2.19-21-2.19-21s-10.5 7.44-25.37 7c-14.87-.44-20.42.29-20.42.29s9.03 6.01 12.97 9.94c3.94 3.94 15.32 5.07 21.45 5.07s13.56-1.31 13.56-1.31Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1440.05 334.61c-30.34 9.28-25.37 45.49-21 81.36 4.37 35.87 10.5 56.86 21 64.3 10.5 7.44 24.49-7 28.87-31.06 4.37-24.06 0-62.99 0-83.98s-14.28-35.08-28.87-30.62ZM1608.13 335.26c-18.38-.03-8.86 60.15-8.42 78.08.44 17.93-19.25 75.67-4.81 76.98 14.43 1.31 40.68-2.19 45.93-11.37 5.25-9.19-4.81-85.29-3.5-101.04 1.31-15.75-3.38-42.6-29.19-42.65Z"
        style={{
          fill: '#899586',
        }}
      />
      <path
        d="M1540.6 191.56c-4.22-1.17-28.89-5.58-43.45 4.61-14.57 10.2-23.79 38.6-23.3 48.79.49 10.2 9.47 12.38 11.17 17.48 1.7 5.1 9.22 15.78 9.22 15.78l65.06-4.61s10.17-3.27 10.9-10.31c.73-7.04-1.46-10.37 1.69-20.08 3.16-9.71 3.67-14.03-.21-28.6-3.88-14.57-13.09-20.75-19.91-22.82-4.65-1.41-6.8.97-11.17-.24Z"
        style={{
          fill: '#d47241',
        }}
      />
      <path
        d="M1541.81 210.5c-4.36.28-15.78 24.52-33.01 30.1-17.24 5.58-18.69 6.31-19.42 11.65-.73 5.34 2.91 12.62 1.46 14.32-1.46 1.7-5.1-7.28-8.25-8.01-3.16-.73-6.8 1.7-4.37 8.98 2.43 7.28 7.77 14.32 10.68 13.84 2.91-.49 4.13-1.21 4.13-1.21s0 8.5 7.53 13.35c7.53 4.86 16.26 16.02 33.26 12.87 16.99-3.16 23.3-15.05 26.22-20.15 2.91-5.1 2.91-13.84 2.91-13.84s7.25 3.49 8.95-.15c1.7-3.64.76-5.92 1-14.9s0-11.89-3.16-11.41 0 16.75-.97 19.42c-.97 2.67-2.18-.73-3.64-3.88-1.46-3.16-5.58-9.95-10.68-23.3-5.1-13.35-5.1-28.16-12.62-27.67Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <g
        style={{
          clipPath: 'url(#grownup-b)',
        }}
      >
        <path
          d="M1536.09 235.06s5.79-3.36 10.11-4.75c4.33-1.39 10.86.3 10.86.3l-.28 3.35s-7.42-.99-9.45.31c-2.33 1.49-9.76 4.7-9.76 4.7s-1.86-4.09-1.48-3.92ZM1523.04 234.37s-5.79-3.36-10.11-4.75c-4.33-1.39-10.86.3-10.86.3l.28 3.35s7.42-.99 9.45.31c2.33 1.49 9.76 4.7 9.76 4.7s1.86-4.09 1.48-3.92Z"
          style={{
            fill: '#c48648',
          }}
        />
      </g>
      <path
        d="M1499.25 282.7s2.48 17.37 1.51 23.41c-.97 6.04 9.28 25.25 18.99 33.98 9.71 8.74 18.12 13.27 18.12 13.27s11.11-11.76 16.83-19.53c5.72-7.77 6.47-18.88 4.75-22.22s-4.1-4.53-4.53-10.14c-.43-5.61 0-12.19 0-12.19l-55.67-6.58Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <g
        style={{
          clipPath: 'url(#grownup-c)',
        }}
      >
        <path
          d="M1473.73 310.02s43.03 23.97 66.03 17.83c28.87-7.72 55.38-19.01 53.55-17.83l5.41 63.1-123.19 13.82-1.8-76.92Z"
          style={{
            fill: '#e6f1e2',
          }}
        />
      </g>
      <path
        d="M1516.48 283.9c1.01 1.51 2.63.63 5.54 2.14 2.91 1.51 5.72.86 10.03.54 4.32-.32 6.4-2.17 8.67-3.14 2.27-.97 3.99-1.52 4.31-2.92.32-1.4-1.23-3.35-3.92-4.54-2.7-1.19-5.39-1.26-7.22-.83-1.83.43-3.45 2.48-5.07 2.27-1.62-.22-3.13-1.4-5.5-.86-2.37.54-3.03 1.03-4.91 2.5s-2.78 3.57-1.92 4.85Z"
        style={{
          fill: '#f2934a',
        }}
      />
      <path
        d="m1545.41 248.1 3.84-.68-.38-1.97-5.02.82s1.41 1.88 1.57 1.82Z"
        style={{
          fill: '#3d6b2a',
        }}
      />
      <path
        style={{
          fill: '#3d6b2a',
        }}
        d="m1544.58 247.36 1.97-5.65-1.61-.64-1.97 5.07 1.61 1.22z"
      />
      <path
        d="M1542.94 244.61c1.92.19 3.15 1.62 2.89 3.49-.26 1.88-1.87 2.79-3.6 2.73-2.05-.07-3.15-1.34-3.09-3.29.05-1.38 1.82-3.13 3.8-2.93ZM1513.29 250.65l-5.16-.99.19-1.8 6.15.87s-1.02 1.96-1.18 1.91Z"
        style={{
          fill: '#3d6b2a',
        }}
      />
      <path
        style={{
          fill: '#3d6b2a',
        }}
        d="m1513.41 249.41-2.29-5.53 1.57-.73 2.25 4.95-1.53 1.31z"
      />
      <path
        d="M1514.89 246.57c-1.91.29-3.05 1.79-2.69 3.65.36 1.86 2.01 2.72 3.74 2.56 2.04-.18 2.79-1.86 2.61-3.81-.12-1.38-1.69-2.7-3.65-2.4Z"
        style={{
          fill: '#3d6b2a',
        }}
      />
      <path
        d="M1562.66 236.7s-8.5-1.48-18.28-.53c-10.56 1.03-10.87 3.98-12.41 5.12-.96.71-1.21.31-3.54.37s-2.53.59-3.56-.02c-1.64-.98-2.24-3.89-12.85-3.89-9.83 0-18.13 1.92-18.13 1.92l-.73 5.24s2.84.12 3.76 4.46c.92 4.34 1.77 13.68 14.14 13.29 12.37-.38 13.66-10.64 14.28-13 .72-2.77.8-4.42 1.67-4.73.56-.2 2.55-.29 3.12-.15.9.22 1.14 1.86 2.12 4.54.84 2.29 3.12 12.37 15.48 11.55 12.35-.82 12.29-10.2 12.79-14.61.49-4.4 2.35-4.45 2.35-4.45l-.22-5.12Zm-45.75 22.23c-4.68 2.72-11.71 1.48-14.48-1.9-2.77-3.38-3.14-8.55-2.87-11.27.41-4.14 4.61-5.14 11.35-5.64 6.74-.5 11.36.81 11.74 5.82.37 5.01-.14 9.74-5.74 12.99Zm39.23-4.95c-2.43 3.63-8.57 6.29-14.46 3.63-5.9-2.66-7.22-7.5-7.33-12.52-.11-5.02 4.62-6.5 11.38-6.66 6.76-.16 11.04.43 11.85 4.51.53 2.68 1 7.41-1.43 11.04Z"
        style={{
          fill: '#e3ebde',
        }}
      />
      <path
        d="M1487.36 274.36c-1.48.23-2.36 1.37-2.05 2.79.3 1.42 1.6 2.07 2.94 1.95 1.59-.15 2.15-1.43 1.99-2.92-.11-1.05-1.35-2.06-2.88-1.82ZM1569.02 267.43c-1.48.23-2.36 1.37-2.05 2.79.3 1.42 1.6 2.07 2.94 1.95 1.59-.15 2.15-1.43 1.99-2.92-.11-1.05-1.35-2.06-2.88-1.82Z"
        style={{
          fill: '#f3decd',
        }}
      />
    </svg>
  )
}
export default GrownupStart
